import StarterKitsIcon from "../../assets/product-list-assets/starter-kits.svg";
import type { ProductListGroup } from "../../types";

export const starterKits: ProductListGroup = {
  id: "starterKits",
  title: "productListGroup.starterKits.title",
  icon: {
    src: StarterKitsIcon,
    width: 20,
    height: 20,
  },
};
